var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Buildings & Landmarks/Building/4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M13.3333 70H16.6666M16.6666 70V13.2C16.6666 12.0799 16.6666 11.5198 16.8846 11.092C17.0763 10.7157 17.3823 10.4097 17.7586 10.218C18.1864 10 18.7465 10 19.8666 10H60.1332C61.2534 10 61.8134 10 62.2412 10.218C62.6176 10.4097 62.9235 10.7157 63.1153 11.092C63.3333 11.5198 63.3333 12.0799 63.3333 13.2V70M16.6666 70H63.3333M63.3333 70H66.6666",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M26.6667 26.6667H33.3334",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14_2",
    d: "M26.6667 40H33.3334",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M26.6667 53.3333H33.3334",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14_3",
    d: "M46.6667 26.6667H53.3334",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14_4",
    d: "M46.6667 40H53.3334",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M46.6667 53.3333H53.3334",
    stroke: "#C1C3C7",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox4);
export default __webpack_public_path__ + "static/media/box4.349ad42d593f42b9ac35301062fa8a9e.svg";
export { ForwardRef as ReactComponent };